const getTranslationKeyOfError = (value) => {
  switch (value) {
    case "403":
      return "pages.authorization.password_recovery_update.texts.1";
    case "404":
      return "pages.authorization.password_recovery_update.texts.2";
    case "422":
      return "pages.authorization.password_recovery_update.texts.3";
    default:
      return "generals.warnings.1";
  }
};

export { getTranslationKeyOfError };
